import React, { ReactElement } from 'react';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';
import { Checkbox } from '@televet/kibble-ui/build/components/Checkbox';
import { VStack } from '@televet/kibble-ui/build/chakra';

interface Props {
  index: number;
  prompt: string;
  options: string[];
  isRequired: boolean;
}

const MultipleSelection = ({ index, prompt, options, isRequired }: Props): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />
      <VStack align="flex-start">
        {options.map((option, optionIndex) => {
          return <Checkbox key={optionIndex}>{option}</Checkbox>;
        })}
      </VStack>
    </QuestionWrapper>
  );
};

export default MultipleSelection;
